/**
 * @description: 异店会员消费报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-yhx-report">
        <div class="member-yhx-list">
            <div class="row row-margin">
                <label class="list-label-4">消费时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="yhxTime">
                        <input type="text" class="form-control laydate-icon" v-model="yhxStartTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="yhxEndTime" />
                    </div>
                </div>
                <div class="col-md-1 ct-col yhx-tit-sel">
                    <select class="form-control" ref="yhx_tit_sel">
                        <option value="1">会员卡所属门店</option>
                        <option value="2">收款门店</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <div class="ct-col" v-show="yhx_field == '1'">
                        <select class="form-control" ref="yhxShop"></select>
                    </div>
                    <div class="ct-col" v-show="yhx_field == '2'">
                        <select class="form-control" ref="yhx_xf_shop"></select>
                    </div>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="yhxQuery_conditions">
                        <option value="vip_card">会员卡号</option>
                        <option value="mobile">会员手机号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="yhxSearch_info" :placeholder="yhxEmployeeinput">
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">消费金额:</label>
                <div class="list-total" ref="yhx_amount"></div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYhxTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYhxExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="yhxList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="yhxExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='yhxExport_allcheck' @click='yhxExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="consume_time">
                            <label>消费时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="vip_shop_name">
                            <label>会员卡所属门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="consume_shop_name">
                            <label>收款门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yhxExport_checkModel' value="amount">
                            <label>消费金额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='yhxExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='yhxExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                yhxStartTime: "",
                yhxEndTime: "",
                yhx_field: '1',
                yhx_init_shop: '',
                yhxSearch_field: "vip_card",
                yhxEmployeeinput: '请输入会员卡号',
                yhxSearch_info: "",
                yhxExport_allcheck: false,
                c_yhxExport_allcheck: false,
                yhxExport_checkModel: [],
                yhxExport_checkData: ['consume_time', 'consume_shop_name', 'vip_shop_name', 'vip_card', 'mobile', 'amount'],
                yhxExport_type: 1,
            }
        },
        watch: {
            yhxExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.yhxExport_checkModel.length >= this.yhxExport_checkData.length) {
                        this.yhxExport_allcheck = true;
                        this.c_yhxExport_allcheck = true;
                    } else {
                        this.yhxExport_allcheck = false;
                        this.c_yhxExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.yhxStartTime = moment().subtract(1, 'day').format('YYYY-MM-DD 08:00');
            _this.yhxEndTime = moment().format('YYYY-MM-DD 08:00');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.yhx_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.yhx_field = $(this).val();
                if(_this.yhx_field == '1') {
                    $(_this.$refs.yhxShop).val(_this.yhx_init_shop).trigger('change');
                    $(_this.$refs.yhx_xf_shop).val('').trigger('change');
                } else {
                    $(_this.$refs.yhxShop).val('').trigger('change');
                    $(_this.$refs.yhx_xf_shop).val(_this.yhx_init_shop).trigger('change');
                }
            });
            $(_this.$refs.yhxQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.yhxSearch_field = $(this).val();
                if(_this.yhxSearch_field == 'vip_card') {
                    _this.yhxEmployeeinput = '请输入会员卡号';
                } else if(_this.yhxSearch_field == 'mobile') {
                    _this.yhxEmployeeinput = '请输入会员手机号';
                }
            });
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.yhxTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.yhxStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.yhxEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.yhxShop).select2({
                                data: _this.shopDatas,
                                language: "zh-CN"
                            });
                            $(_this.$refs.yhx_xf_shop).select2({
                                data: _this.shopDatas,
                                language: "zh-CN",
                                width: '100%'
                            });
                            _this.yhx_init_shop = data.response.result[1].id;
                            $(_this.$refs.yhxShop).val(_this.yhx_init_shop).trigger('change');
                            _this.innitYhxTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 初始化异店会员消费报表
            innitYhxTable: function() {
                let _this = this;
                $(_this.$refs.yhxList).bootstrapTable('destroy');
                $(_this.$refs.yhxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYhxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "consume_time",
                        title: "消费时间",
                        width: "13%",
                        valign: 'middle'
                    }, {
                        field: "vip_shop_name",
                        title: "会员卡所属门店",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "consume_shop_name",
                        title: "收款门店",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "11%",
                        valign: 'middle'
                    }, {
                        field: "mobile",
                        title: "会员手机号",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "amount",
                        title: "消费金额",
                        width: "9%",
                        valign: 'middle'
                    }]
                });
            },
            // 获取异店会员消费报表
            getYhxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let vip_card = '',
                    mobile = '';
                if(_this.yhxSearch_field == 'vip_card') {
                    vip_card = _this.yhxSearch_info;
                } else if(_this.yhxSearch_field == 'mobile') {
                    mobile = _this.yhxSearch_info;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.yhxStartTime,
                            "end_time": _this.yhxEndTime,
                            "vip_shop_id": _this.yhx_field == '1' ? $(_this.$refs.yhxShop).val() : '',
                            "consume_shop_id": _this.yhx_field == '2' ? $(_this.$refs.yhx_xf_shop).val() : '',
                            "vip_card": vip_card,
                            "mobile": mobile
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getDiffShopVipConsumeReport",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $(_this.$refs.yhx_amount).text(data.response.result.amount_total);
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYhxExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/diffshopVipConsumeExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.yhxExport_checkModel = data.response.result.export_fields;
                                _this.yhxExport_type = data.response.result.export_type;
                            } else {
                                _this.yhxExport_checkModel = _this.yhxExport_checkData;
                                _this.yhxExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.yhxExport_alert)
                }, function() {
                    _this.exportYhxList();
                });
            },
            // 导出字段全选
            yhxExportCheckedAll: function() {
                let _this = this;
                _this.yhxExport_allcheck = _this.c_yhxExport_allcheck;
                if(!_this.yhxExport_allcheck) { // 实现全选
                    _this.yhxExport_checkModel = [];
                    _this.yhxExport_checkData.forEach(function(item) {
                        _this.yhxExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.yhxExport_checkModel = [];
                }
            },
            // 确定“导出”
            exportYhxList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.yhxExport_checkModel);
                let vip_card = '',
                    mobile = '';
                if(_this.yhxSearch_field == 'vip_card') {
                    vip_card = _this.yhxSearch_info;
                } else if(_this.yhxSearch_field == 'mobile') {
                    mobile = _this.yhxSearch_info;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/diffshopVipConsumeExport?" +
                    "&start_time=" + _this.yhxStartTime +
                    "&end_time=" + _this.yhxEndTime +
                    "&vip_shop_id=" + (_this.yhx_field == '1' ? $(_this.$refs.yhxShop).val() : '') +
                    "&consume_shop_id=" + (_this.yhx_field == '2' ? $(_this.$refs.yhx_xf_shop).val() : '') +
                    "&vip_card=" + vip_card +
                    "&mobile=" + mobile +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.yhxExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-yhx-list {
        .yhx-tit-sel {
            width: 130px;
            padding: 0;
        }
    }
</style>